import { useEffect } from 'react';

import type { ActivitySection } from '@strava/mre';

import { getWorldLine2FromLatLngArray } from '../../helpers/getWorldLine2FromLatLngArray';
import { useMRE } from '../../hooks/useMRE';
import { LatLng } from '../../types';

interface ActivityProps {
  id: string;
  polyline: LatLng[];
  activitySections?: ActivitySection[];
}

/*
 * This component renders a single Activity on a map, e.g. Logged out ADP
 */
export const Activity = ({
  id,
  polyline,
  activitySections = []
}: ActivityProps) => {
  const { terrainEngine } = useMRE();

  useEffect(() => {
    if (!terrainEngine || !polyline) {
      return;
    }

    terrainEngine
      .getContent()
      .getActivityContent()
      .displayActivity2(
        id,
        getWorldLine2FromLatLngArray(polyline),
        activitySections
      );

    return () => {
      terrainEngine.getContent().getActivityContent().removeActivity(id);
    };
  }, [terrainEngine, id, polyline, activitySections]);

  return null;
};
